import { AnimatePresence } from "motion/react";
import { FC, useState } from "react";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl } from "@ryde/controls";
import { ISettingsGroup } from "@ryde/shared";

import { SettingItem } from "./settings.item";
import {
  SettingsGroupContainerStyled,
  SettingsGroupHeaderStyled,
} from "./settings.styled";

interface ISettingsGroupHeader {
  groupTitle: string;
  collapsed?: boolean;
  toggleCollapse: () => void;
}

const SettingsGroupHeader: FC<ISettingsGroupHeader> = ({
  groupTitle,
  collapsed,
  toggleCollapse,
}) => {
  return (
    <SettingsGroupHeaderStyled
      type="button"
      aria-expanded={!collapsed}
      onClick={() => toggleCollapse()}
    >
      {groupTitle}
      {!collapsed && (
        <SVG_MUI.ChevronDownSVG
          className="collapse_toggle"
          title="Collapse grouping"
          aria-hidden="true"
          focusable="false"
        />
      )}
      {!!collapsed && (
        <SVG_MUI.ChevronUpSVG
          className="collapse_toggle"
          title="Expand grouping"
          aria-hidden="true"
          focusable="false"
        />
      )}
    </SettingsGroupHeaderStyled>
  );
};

export const SettingsGroup: FC<ISettingsGroup> = ({
  groupTitle,
  groupItems,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = useEvent(() => {
    setCollapsed(!collapsed);
  });

  return (
    <SettingsGroupContainerStyled>
      <SettingsGroupHeader
        toggleCollapse={toggleCollapse}
        collapsed={collapsed}
        groupTitle={groupTitle}
      />
      <AnimatePresence>
        {!collapsed && (
          <>
            {groupItems.map(x =>
              x.skipPermissionCheck ? (
                <SettingItem key={x.title} {...x} />
              ) : (
                <AccessControl
                  key={x.title}
                  entity={x.permission?.entity}
                  action={x.permission?.action}
                >
                  <SettingItem {...x} />
                </AccessControl>
              ),
            )}
          </>
        )}
      </AnimatePresence>
    </SettingsGroupContainerStyled>
  );
};
